import React from 'react'

import styles from './styles.module.css'

export default function(props) {
  const { width, height, line } = props
  const lineWidth = 70

  return (
    <div className={styles.legendItem}>
      <svg width={width} height={height}>
        <g key={line.title} transform={`translate(${10},${10})`}>
          <line
            x1="0"
            y1="0"
            x2={lineWidth}
            y2="0"
            stroke={line.color}
            strokeWidth="3"
            strokeDasharray={line.strokeDasharray}
          />
          <circle
            r="3"
            cx={lineWidth / 2}
            cy="0"
            fill={line.color}
            stroke={line.color}
            strokeWidth="3"
          />
        </g>
      </svg>
      <span>{line.title}</span>
    </div>
  )
}
